// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const FILL_PLATE_STEP_SHAPES = [
  {
    stepType: PipelineStepType.FILL_PLATE,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      Contents: {
        systemName: 'Contents',
        displayName: 'Contents',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      Labels: {
        systemName: 'Labels',
        displayName: 'Labels',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      Metadata: {
        systemName: 'Metadata',
        displayName: 'Metadata',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      }
    },
    outputDataShapes: {
      Outputs: {
        systemName: 'Outputs',
        displayName: 'Outputs',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      Errors: {
        systemName: 'Errors',
        displayName: 'Errors',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Output plates': {
        systemName: 'Output plates',
        displayName: 'Output plates',
        kind: PipelineStepDataKind.PLATE,
        isMulti: true,
        isRequired: true
      }
    },
    config: {
      name: {
        kind: 'string',
        required: true
      },
      plateDesignTemplateId: {
        kind: 'domain',
        required: false,
        types: [
          'PLATE_DESIGN_TEMPLATE'
        ]
      },
      plateHeight: {
        kind: 'integer',
        required: false
      },
      plateWidth: {
        kind: 'integer',
        required: false
      },
      plateSchemaId: {
        kind: 'domain',
        required: false,
        types: [
          'PLATE_SCHEMA'
        ]
      },
      contentConcentrationUnitId: {
        kind: 'domain',
        required: false,
        types: [
          'UNIT'
        ]
      },
      transferQuantityUnitId: {
        kind: 'domain',
        required: false,
        types: [
          'UNIT'
        ]
      },
      wellVolumeUnitId: {
        kind: 'domain',
        required: false,
        types: [
          'UNIT'
        ]
      },
      contentsColumnMapping: {
        kind: 'columnMapping',
        required: true,
        fields: {
          plate_id: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          plate_index: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          well_position: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          row_index: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          column_index: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          entity_id: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          container_id: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          content_layer_name: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          content_concentration_amount: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          transfer_quantity_amount: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Contents',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          }
        }
      },
      labelsColumnMapping: {
        kind: 'columnMapping',
        required: false,
        fields: {
          well_position: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Labels',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          row_index: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Labels',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          column_index: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Labels',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          role: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Labels',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          subrole: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Labels',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          group: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Labels',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          sample_schema_id: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Labels',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          well_volume_amount: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Labels',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          }
        }
      },
      metadataColumnMapping: {
        kind: 'columnMapping',
        required: false,
        fields: {
          well_position: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Metadata',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.TEXT
              ]
            }
          },
          row_index: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Metadata',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          },
          column_index: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Metadata',
            allowMissingColumn: false,
            validationOptions: {
              allowedLeafTypes: [
                LeafType.INTEGER,
                LeafType.DECIMAL
              ]
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
